import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { FiDateTimeFormatOptions } from '@fi-shared/utils/format-date';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { RollupContentComponent } from '@fi-shared/rollup/rollup-content.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IVersionListColumn } from '@fi-app/utilities/versions-list/versions-list.component';
import { AppTextService } from '@fi-shared/app-text';
import { IDocumentVersionModel } from '@fi-app/document/document';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-document-version-list',
    template: `
        <fi-versions-list
            [versionsFields]="Fields"
            [versionsList]="VersionsList"
            [currentVersion]="activeVersion"
            (versionClick)="DocumentVersionClick($event)"
            [startAsVisible]="startAsVisible"
            (afterOpen)="onVersionsOpened($event)"
        ></fi-versions-list>
    `,
    styleUrls: ['./version-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-document-version-list' },
    standalone: false,
})
export class DocumentVersionListComponent implements OnChanges, OnInit {
    @Input() documentId: number;
    @Input() originalDocumentVersions: IDocumentVersionModel[] = [];
    @Input() documentVersions: IDocumentVersionModel[] = [];
    @Input() isDraft: boolean;

    @Input() startAsVisible: boolean;
    @Input() languageId: number;
    @Input() replaceState: boolean = false;

    @Output() versionsOpened = new EventEmitter<RollupContentComponent>();
    @Output() versionClick = new EventEmitter();

    VersionsList: IDocumentVersionModel[] = [];
    activeVersion: IDocumentVersionModel;

    constructor(
        private stateService: FiStateService,
        private appTextService: AppTextService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    ngOnInit(): void {
        this.Fields = [
            {
                Name: 'Id',
                Title: this.appTextService.get('common.version'),
                Content: (version: IDocumentVersionModel) => {
                    let result = 'Version ' + version.DocumentVersion;
                    if (this.GetDocumentActiveVersion() == version) result += ' (Active version)';

                    /*if (version.IsDraft) // todo why version has no IsDraft property?
                        result += ' (Auto saved)';*/

                    return result;
                },
            },
            {
                Name: 'CreatedByUserName',
                Title: this.appTextService.get('user.user'),
            },
            {
                Name: 'CreatedOn',
                Title: this.appTextService.get('common.date'),
                Content: (version: IDocumentVersionModel) =>
                    this.fiFormatDateService.formatDate(version.CreatedOn, FiDateTimeFormatOptions),
            },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.languageId || changes.originalDocumentVersions || changes.documentVersions) {
            this.VersionsList = (this.isDraft ? this.originalDocumentVersions : this.documentVersions).filter(
                (version) => version.ContentLanguageId === this.languageId,
            );

            this.activeVersion = this.GetDocumentActiveVersion();

            // let draftVersion;
            // if (this.document.IsDraft) {
            //     draftVersion = JSON.parse(JSON.stringify(this.document.DocumentVersions[0]));
            // } else if (this.document.DraftVersion) {
            //     draftVersion = JSON.parse(JSON.stringify(this.document.DraftVersion));
            // }

            // let lastActiveVersion = this.activeVersion ? this.activeVersion.DocumentVersion : 0;

            // if (draftVersion) {
            //draftVersion.IsDraft = true;
            //draftVersion.DocumentVersion = lastActiveVersion + 1;
            //this.VersionsList.push(draftVersion);
            // }
        }
    }

    Fields: IVersionListColumn[];

    GetDocumentActiveVersion() {
        let result: IDocumentVersionModel;
        this.VersionsList.forEach((version) => {
            if (!result || version.DocumentVersion > result.DocumentVersion) result = version;
        });

        return result;
    }

    DocumentVersionClick(DocumentVersion: IDocumentVersionModel) {
        const activeVersion = this.GetDocumentActiveVersion();
        const options: any = {};
        if (this.replaceState) options.location = 'replace';

        if (
            /*DocumentVersion.IsDraft !== true &&*/
            !activeVersion ||
            DocumentVersion.DocumentVersion !== activeVersion.DocumentVersion
        ) {
            this.versionClick.emit(DocumentVersion);

            this.stateService.go(
                FiStateNames.Document.Version,
                {
                    DocumentId: this.documentId,
                    VersionId: DocumentVersion.Id,
                    languageId: this.stateService.params.languageId,
                },
                options,
            );
        }
    }

    onVersionsOpened($event: RollupContentComponent) {
        this.versionsOpened.emit($event);
    }
}
